import styled from "styled-components";
import { PagesAccountCopyUiInput } from "./Input";
import { PagesAccountCopyUiResults } from "./Results";
import { Alert } from "@dealer-center/core-components";
import { useMediaLibraryCopyPerformCopy } from "@dealer-center/ddc-pages-media-library-copy-fetch";
import { useState } from "react";
import { useGetAccountId } from "@dealer-center/ddc-api-account-fetch";

const StyledPagesAccountCopyUi = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`;

const StyledPageHeader = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1rem;
`;
export const PagesAccountCopyUiDisplay = () => {
  const [targetAccountId, setTargetAccountId] = useState("");
  const selectedDealer = useGetAccountId();
  const performCopyMutation = useMediaLibraryCopyPerformCopy();
  const performCopy = (destinationAccount: string) => {
    if (!selectedDealer) {
      return;
    }
    setTargetAccountId(destinationAccount);
    performCopyMutation.mutate({
      targetAccountId: destinationAccount,
      sourceAccountId: selectedDealer
    });
  };
  return (
    <StyledPagesAccountCopyUi>
      <StyledPageHeader>
        Copy Media Library Assets To Another Account
      </StyledPageHeader>
      <Alert role="alert" sx={{ marginBottom: "16px" }} type={"info"}>
        <>
          To copy Media Library assets (PFDs, images, and videos) from this
          Dealer.com account to another, enter a valid destination account id in
          the input box below and hit Submit.
          <br />
          Running this will not remove the assets, nor will it modify the
          library structure from this account. It will not overwrite folders or
          assets in the destination account. It will merge the two libraries
          into the destination account. Locked folders, and inherited folders
          will not copy from the source account to the destination account.
        </>
      </Alert>
      <PagesAccountCopyUiInput performCopy={performCopy} />
      <PagesAccountCopyUiResults
        performCopyMutation={performCopyMutation}
        targetAccountId={targetAccountId}
      />
    </StyledPagesAccountCopyUi>
  );
};
